<template>
  <label :for="forId" :id="id" class="form-label">
    <slot></slot>
    <abbr v-if="required" title="required" aria-hidden="true" class="ms-1">*</abbr>
  </label>
</template>

<script>
  export default {
    props: {
      forId: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: undefined
      },
      required: {
        type: Boolean,
        required: false
      }
    }
  }
</script>
